import { render, staticRenderFns } from "./chooseRecords.vue?vue&type=template&id=695bb2b8&scoped=true&"
import script from "./chooseRecords.vue?vue&type=script&lang=js&"
export * from "./chooseRecords.vue?vue&type=script&lang=js&"
import style0 from "./chooseRecords.vue?vue&type=style&index=0&id=695bb2b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695bb2b8",
  null
  
)

export default component.exports